import { createAsyncThunk } from "@reduxjs/toolkit";
import { APICore } from "../../helpers/api/apiCore";
import * as Url from "../../helpers/api/ApiEndpoint";
import { showError, showSuccess } from "../../helpers/toaster";

const api = new APICore();


export const getGalleryData = createAsyncThunk(
  "gallery/getGalleryData",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get(`${Url.GET_GALLERY}?type=${data.type}`);
      return response.data;
    } catch (error) {
      showError(error)
      // return rejectWithValue(error);
    }
  }
);

export const getGalleryDataById = createAsyncThunk(
  "gallery/getGalleryDataById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get(`${Url.GET_GALLERY_BY_ID}?modelId=${data?.modelId}&type=${data?.type}`);
      return response.data;
    } catch (error) {
      showError(error)
      // return rejectWithValue(error);
    }
  }
);

export const deleteMedia = createAsyncThunk(
  "gallery/deleteMedia",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.delete(`${Url.DELETE_MEDIA}?mediaId=${data.mediaId}`);
      showSuccess(response.data.message);
      return response.data;
    } catch (error) {
      showError(error)
      // return rejectWithValue(error);
    }
  }
);
